import { useState, useCallback } from 'react';
import { submitRating as submitRatingRequest } from '@api/ratings';

export function useRatings() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submitRating = useCallback(async (payload) => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await submitRatingRequest(payload);
      return data;
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to submit rating');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    submitRating,
    loading,
    error,
  };
}

